import { asNullableMeasure, asNullableSiValue, type Measure, type SiValue, type Stored } from "lab-testing-units";
import { WATER_CONTENT_MASS } from "./units";

export interface WaterContentContract {
  balance: string | null;
  container: string | null;
  containerMass: Measure | null;
  wetSoilContainerMass: Measure | null;
  oven: string | null;
  dryingMethod: string | null;
  dryingStartAt: string | null;
  dryingEndAt: string | null;
  drySoilContainerMass: Measure | null;
  readonly initialWetMass: SiValue | null;
  readonly massOfWater: SiValue | null;
  readonly totalDryMass: SiValue | null;
  readonly waterContent: number | null;
}

export const asWaterContentContract = (raw: unknown): WaterContentContract => {
  const stored = raw as Stored<WaterContentContract>;
  return {
    ...stored,
    containerMass: asNullableMeasure(stored?.containerMass, WATER_CONTENT_MASS),
    wetSoilContainerMass: asNullableMeasure(stored?.wetSoilContainerMass, WATER_CONTENT_MASS),
    drySoilContainerMass: asNullableMeasure(stored?.drySoilContainerMass, WATER_CONTENT_MASS),
    initialWetMass: asNullableSiValue(stored?.initialWetMass, WATER_CONTENT_MASS),
    massOfWater: asNullableSiValue(stored?.massOfWater, WATER_CONTENT_MASS),
    totalDryMass: asNullableSiValue(stored?.totalDryMass, WATER_CONTENT_MASS),
  };
};

export const asNullableWaterContentContract = (raw: unknown): WaterContentContract | null =>
  raw == null ? null : asWaterContentContract(raw);
